module.exports = __webpack_public_path__ + "img/ic_dropdown.17eb370c.svg";